export const fillEraMinMaxWithDate = (eras: { name: string, value: string, min?: number, max?: number }[], date: Date, isToday: boolean = false): { name: string, value: string, min?: number, max?: number }[] => {
  const year = date.getFullYear();
  return eras.map(era => {
    const filledEra = Object.assign({}, era);
    if (!["令和", "西暦"].includes(era.name)) {
      return filledEra;
    }
    const currentYear = era.name === "令和" ? (year - 2018) : year;
    
    if (era.min === undefined) {
      if (isToday) {
        if (date.getMonth() < 3) {
          filledEra.min = currentYear - 1;
        } else {
          filledEra.min = currentYear;
        }
      }
    }
    
    if (era.max === undefined) {
      if (date.getMonth() >= 11) {
        filledEra.max = currentYear + 1;
      } else {
        filledEra.max = currentYear;
      }
    }
    console.log(filledEra);
    return filledEra;
  });
}

export const fillEraMinMax = (eras: { name: string, value: string, min?: number, max?: number }[], isToday: boolean = true): { name: string, value: string, min?: number, max?: number }[] => {
  return fillEraMinMaxWithDate(eras, new Date(), isToday);
}
